import React, { ReactElement, useEffect, useMemo, useState } from 'react';
import Theme from '../components-library/Theme';
import { useWindowSize } from '../hooks/utility/useWindowSize';
import { SCREEN_TYPES } from '../services/exports/Constants';

interface Props {
  children: ReactElement;
}

export interface ScreenTypeContextInterface {
  isDesktop: boolean;
  isTablet: boolean;
  isMobile: boolean;
}

export const ScreenTypeContext = React.createContext<ScreenTypeContextInterface>(null);

const ScreenTypeProvider = (props: Props): JSX.Element => {
  const { children } = props;

  const windowSize = useWindowSize();

  const [screenType, setScreenType] = useState<SCREEN_TYPES>(SCREEN_TYPES.DESKTOP);
  const width = windowSize.width ?? 0;

  function handleResize() {
    if (width >= Theme.screens.lg) {
      return setScreenType(SCREEN_TYPES.DESKTOP);
    }

    if (width >= Theme.screens.md) {
      return setScreenType(SCREEN_TYPES.TABLET);
    }

    return setScreenType(SCREEN_TYPES.MOBILE);
  }

  useEffect(() => {
    handleResize();
  }, [width]);

  const context = useMemo<ScreenTypeContextInterface>(
    () => ({
      isDesktop: screenType === SCREEN_TYPES.DESKTOP,
      isTablet: screenType === SCREEN_TYPES.TABLET,
      isMobile: screenType === SCREEN_TYPES.MOBILE,
    }),
    [screenType, windowSize],
  );

  return <ScreenTypeContext.Provider value={context}>{children}</ScreenTypeContext.Provider>;
};

export default ScreenTypeProvider;
